var isEnterEvent = function isEnterEvent(event) {
  var keyCode = event.key;
  return keyCode === 'Enter';
};

var isArrowDownKey = function isArrowDownKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowDown';
};

var isArrowUpKey = function isArrowUpKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowUp';
};

var isArrowLeftKey = function isArrowLeftKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowLeft';
};

var isArrowRightKey = function isArrowRightKey(event) {
  var keycode = event.key;
  return keycode === 'ArrowRight';
};

var addScript = function addScript(scriptURl, opts) {
  if (typeof window !== 'undefined') {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptURl;
    script.async = opts.async || false;
    script.onload = opts.onload || null;
    var position = document.querySelector(opts.position || 'body');

    if (position) {
      position.append(script);
    }
  }
};

// this method add delay in resolving the promise
var promiseDelay = function promiseDelay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
var getScreenSize = function getScreenSize() {
  var width = '_';
  var height = '_';

  if (window.screen && window.screen.width) {
    width = window.screen.width ? window.screen.width : '_';
    height = window.screen.height ? window.screen.height : '_';
  }

  return {
    width: width,
    height: height
  };
};
var getActiveFont = function getActiveFont() {
  var fontsActive = window.getComputedStyle(document.getElementsByTagName('body')[0]).fontFamily.split(', ').map(function (elem) {
    return elem.replace(/"/g, '');
  });
  return fontsActive;
};

export { addScript, getActiveFont, getScreenSize, isArrowDownKey, isArrowLeftKey, isArrowRightKey, isArrowUpKey, isEnterEvent, promiseDelay };
